import { render } from "./HomeObligation.vue?vue&type=template&id=265b6727"
import script from "./HomeObligation.vue?vue&type=script&lang=js"
export * from "./HomeObligation.vue?vue&type=script&lang=js"

import "./HomeObligation.vue?vue&type=style&index=0&id=265b6727&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/HomeObligation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "265b6727"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('265b6727', __exports__)) {
    api.reload('265b6727', __exports__)
  }
  
  module.hot.accept("./HomeObligation.vue?vue&type=template&id=265b6727", () => {
    api.rerender('265b6727', render)
  })

}


export default __exports__